"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsBridge = exports.isNative = void 0;

var _util = require("./util");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isNative = typeof window !== 'undefined' && typeof window.getCurrentRunEnv !== 'undefined';
exports.isNative = isNative;
var _jsBridgeSingleton = null;

var JsBridge = /*#__PURE__*/function () {
  function JsBridge() {
    _classCallCheck(this, JsBridge);

    this.callbacksPool = {};
  }

  _createClass(JsBridge, [{
    key: "_getCallbacks",
    value: function _getCallbacks(method) {
      if (!this.callbacksPool[method]) {
        this.callbacksPool[method] = {};
      }

      return this.callbacksPool[method];
    }
  }, {
    key: "invoke",
    value: function invoke(api, data, successCallback, failCallback) {
      var nonceStr = (0, _util.getNonce)(16);

      var callbacks = this._getCallbacks(api);

      callbacks[nonceStr] = {
        success: successCallback,
        fail: failCallback
      };
      window.modouNativeBridge.postMessage(JSON.stringify({
        api: api,
        data: data || {},
        key: nonceStr
      }));
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(msg) {
      var key = msg.key,
          api = msg.api;

      var callbacks = this._getCallbacks(api);

      if (callbacks[key]) {
        var _callbacks$key = callbacks[key],
            success = _callbacks$key.success,
            fail = _callbacks$key.fail;

        try {
          success && success(msg);
        } catch (err) {
          fail && fail(msg);
        }

        delete callbacks[key];
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!_jsBridgeSingleton) {
        _jsBridgeSingleton = new JsBridge();
      }

      return _jsBridgeSingleton;
    }
  }]);

  return JsBridge;
}();

exports.JsBridge = JsBridge;